import type { z } from "zod";
import type { managedTenantContextSchema } from "@/lib/managed-contract";

export type TenantAuthority = z.infer<typeof managedTenantContextSchema>;

export function administrationAccessLabel(authority: TenantAuthority): string {
  if (authority.access === "disabled") return "No console access";
  if (authority.access === "full") return "Full administration";
  return authority.permissions.some(permission => /\.(write|manage|decide|invite|revoke|delete|activate|certify)$/.test(permission))
    ? "Limited administration" : "View only";
}

// The dashboard and inbox require report access; their data must never be
// loaded simply because an administrator is native or has some other service.
export function canReadTenantHome(authority: TenantAuthority): boolean {
  return authority.permissions.includes("reports.read") && authority.permissions.includes("tenant_settings.read");
}
